import React, { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router';
import { JITSI_CONFIG_OVERWRITE, JITSI_INTERFACE_CONFIG_OVERWRITE } from '../../../config/jitsiConfig';
import { base64UrlDecode } from '../../../utils/utility';

const JitsiMeetComponent = (): ReactElement => {
  const { id }: any = useParams();

  useEffect((): any => {
    try {
      const { meetingLink, userName, userEmail, reason } = JSON.parse(base64UrlDecode(id));
      if (!meetingLink || !reason) {
        throw new Error('Incomplete data');
      }
      startMeet(meetingLink, userName, userEmail);
    } catch (e) {
      window.close();
    }
  }, [id]);

  const onMeetClose = (): any => {
    window.close();
  };

  const startMeet = (meetingLink: string, userName: string, userEmail: string): any => {
    const options = {
      roomName: meetingLink,
      parentNode: document.querySelector('#meet'),
      userInfo: {
        email: userEmail,
        displayName: userName,
        role: 'moderator',
      },
      configOverwrite: {
        ...JITSI_CONFIG_OVERWRITE,
        prejoinPageEnabled: (!userName || !userEmail),
      },
      interfaceConfigOverwrite: JITSI_INTERFACE_CONFIG_OVERWRITE,
    };

    const jitsiMeet = new (window as any).JitsiMeetExternalAPI(process.env.REACT_APP_JITSI_BASE_URL, options);
    jitsiMeet.addListener('videoConferenceLeft', onMeetClose);
    jitsiMeet.addEventListener('participantRoleChanged', (event: any): any => {
      if (event.role === 'moderator') {
        jitsiMeet.executeCommand('toggleLobby', true);
      }
    });
  };

  return (
    <div id="meet" className="jitsi-container" />
  );
};
export default JitsiMeetComponent;
